import { http_post_silent } from "./api";

/* eslint-disable @typescript-eslint/no-explicit-any */
const YM_ID = Number(import.meta.env.VITE_YM_ID || 0);
let ymLoaded = false;

/** Loads Yandex.Metrica once (only if a counter id was set at build time). */
export function initAnalytics(): void {
  if (!YM_ID || ymLoaded || typeof window === "undefined") return;
  ymLoaded = true;
  const w = window as any;
  w.ym =
    w.ym ||
    function (...args: unknown[]) {
      (w.ym.a = w.ym.a || []).push(args);
    };
  w.ym.l = Date.now();
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://mc.yandex.ru/metrika/tag.js";
  document.head.appendChild(s);
  w.ym(YM_ID, "init", { clickmap: true, trackLinks: true, accurateTrackBounce: true, webvisor: false });
}

type Step = "open" | "view_product" | "add_to_cart" | "checkout";
const sent = new Set<string>();

/** Funnel step for the admin "Воронка" + a Metrica goal. De-duplicated per session. */
export function track(step: Step, productId?: string): void {
  const key = `${step}:${productId ?? ""}`;
  if (sent.has(key)) return;
  sent.add(key);
  http_post_silent("/api/funnel", { step, productId });
  if (YM_ID) (window as any).ym?.(YM_ID, "reachGoal", step);
}

export function goal(name: string): void {
  if (YM_ID) (window as any).ym?.(YM_ID, "reachGoal", name);
}
